import React from 'react';
import ReactPaginate from 'react-paginate';

const paginationStyles = `
.pagination {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 2rem 0;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}
.pagination__page,
.pagination__next,
.pagination__previous {
  display: inline-block;
}
.pagination__pageLink,
.pagination__nextLink,
.pagination__previousLink {
  display: inline-block;
  padding: 0.5em 1em;
  border-radius: 4px;
  background: #fff;
  color: #3273dc;
  border: 1px solid #dbdbdb;
  cursor: pointer;
  font-size: 1rem;
  transition: background 0.2s, color 0.2s;
  text-decoration: none;
}
.pagination__pageLink:hover,
.pagination__nextLink:hover,
.pagination__previousLink:hover {
  background: #3273dc;
  color: #fff;
}
.active .pagination__pageLink {
  background: #3273dc;
  color: #fff;
  border-color: #3273dc;
}
.ellipsis {
  padding: 0.5em 1em;
  color: #888;
  font-size: 1rem;
}
`;

export default function Pagination({ itemCount, pageSize, currentPage = false, onPageChange }) {
    if (pageSize >= itemCount) return null;

    let pageCount = Math.ceil(itemCount / pageSize);

    const handlePageClick = data => {
        let selected = data.selected + 1;
        onPageChange(selected);
    }

    return (
        <>
            <style>{paginationStyles}</style>
            <ReactPaginate
                forcePage={currentPage}
                previousLabel={'<'}
                nextLabel={'>'}
                breakLabel={'...'}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName={'pagination'}
                pageClassName={'pagination__page'}
                pageLinkClassName={'pagination__pageLink'}
                nextClassName={'pagination__next'}
                nextLinkClassName={'pagination__nextLink'}
                previousClassName={'pagination__previous'}
                previousLinkClassName={'pagination__previousLink'}
                breakClassName={'ellipsis'}
                activeClassName={'active'}
            />
        </>
    )
}
